module.exports = __webpack_public_path__ + "@/assets/img/nadaporaca.e1fd0dcc.svg";